import { render, staticRenderFns } from "./ClassRoomSummary.vue?vue&type=template&id=123df2d6&scoped=true"
import script from "./ClassRoomSummary.vue?vue&type=script&lang=js"
export * from "./ClassRoomSummary.vue?vue&type=script&lang=js"
import style0 from "./ClassRoomSummary.vue?vue&type=style&index=0&id=123df2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123df2d6",
  null
  
)

export default component.exports